import {
	AddEffectiveMaterialPriceMutation,
	CorrectMaterialPriceMutation,
	VoidMaterialPriceMutation
} from "~/gql/mutations/produce/materialPrice.generated";
import {
	GetMaterialPriceActionPreviewQuery,
	GetMaterialPriceHistoryQuery,
	GetMaterialPriceWriteCapabilityQuery
} from "~/gql/queries/produce/materialPrice.generated";

const materialPriceEndpoints = {
	AddEffectiveMaterialPrice: {
		invalidatesTags: [
			"MaterialItems",
			"VendorMaterialCosts",
			"JobCosts",
			"ProductionJobs",
			"ProductionRecipe"
		] as AddTagTypes,
		transformResponse: (res: AddEffectiveMaterialPriceMutation) => {
			return res;
		}
	},
	CorrectMaterialPrice: {
		invalidatesTags: [
			"MaterialItems",
			"VendorMaterialCosts",
			"JobCosts",
			"ProductionJobs",
			"ProductionRecipe"
		] as AddTagTypes,
		transformResponse: (res: CorrectMaterialPriceMutation) => {
			return res;
		}
	},
	GetMaterialPriceActionPreview: {
		transformResponse: (res: GetMaterialPriceActionPreviewQuery) => {
			return res;
		}
	},
	GetMaterialPriceHistory: {
		providesTags: ["VendorMaterialCosts"] as AddTagTypes,
		transformResponse: (res: GetMaterialPriceHistoryQuery) => {
			return res;
		}
	},
	GetMaterialPriceWriteCapability: {
		transformResponse: (res: GetMaterialPriceWriteCapabilityQuery) => {
			return res;
		}
	},
	VoidMaterialPrice: {
		invalidatesTags: [
			"MaterialItems",
			"VendorMaterialCosts",
			"JobCosts",
			"ProductionJobs",
			"ProductionRecipe"
		] as AddTagTypes,
		transformResponse: (res: VoidMaterialPriceMutation) => {
			return res;
		}
	}
};

export default materialPriceEndpoints;
